import DataTable, { createTheme } from "react-data-table-component";
import { Button } from "react-bootstrap";
import React from "react";
export const useCustomStyles = () => {
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "hsl(205, 99%, 38%)",
        color: "white",

        fontWeight: "bold",
        fontSize: "15px",
        display: "flex",
      },
    },
    cells: {
      style: {
        border: "1px solid  whitesmoke",
        display: "flex",
        justifyContent: "center",
      },
    },
  };

  return customStyles;
};

export const useCreateTheme = () => {
  createTheme("solarized", {
    context: {
      text: "#FFFFFF",
    },

    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  });
};

export const useColumns = (addToCompare) => {
  const columns = [
    {
      name: "Packages",
      cell: (value) => (
        <div>
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img
              src={value.image}
              style={{
                objectFit: "cover",

                padding: 10,
              }}
              alt="..."
            />
          </a>
          <div style={{ padding: "10px" }}>
            <p>{value.package_name}</p>
          </div>
        </div>
      ),
    },
    {
      name: "On Net Minutes",
      selector: "details.free_on_net_minutes",
      sortable: true,
    },
    {
      name: "Off Net Minutes",
      selector: "details.free_off_net_minutes",
      sortable: true,
    },
    {
      name: "Free Sms",
      selector: "details.free_sms",
      sortable: true,
    },
    {
      name: "Validity",
      selector: "details.validity",
      sortable: true,
    },
    {
      name: "Free Mbs",
      selector: "details.free_mbs",
      sortable: true,
    },
    {
      name: "Price",
      selector: "price",

      sortable: true,
    },
  ];
  return columns;
};
